import { isEmpty } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useReportStore } from '@store';

export const useIsEdit = () => {
  const { pathname } = useLocation();
  const { report } = useReportStore();

  return (
    pathname.includes('/reporting/edit/') ||
    pathname.includes('/reporting/items/') ||
    !isEmpty(report?.id)
  );
};
